import { Component, OnInit, Inject, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, FormGroup } from '@angular/forms';
import { RetestService } from 'app/services/retest-service';
import { Retest } from 'app/models/retest/retest';
import { OregonWellDataService } from 'app/services/oregon-well-data.service';
import { AuthService } from '@shared/auth/auth.service';

/*
 * Edit Retest Dialog
 */
@Component({
  selector: 'dialog-retests-edit',
  templateUrl: 'retests-edit-dialog.html',
  styleUrls: ['./retests-edit-dialog.scss']
})
export class DialogEditRetestsComponent implements OnInit {
  @Input('retestId')
  retestId: number = 0;
  loading: boolean = false;
  processing: boolean = false;
  retestForm = new FormGroup({
    id: new FormControl(0),
    isComplete: new FormControl({ value: false, disabled: false }),
    incomplete: new FormControl({ value: false, disabled: false }),
    retestType: new FormControl({ value: '', disabled: true }),
    orgininalSampleId: new FormControl({ value: 0, disabled: true }),
    retestSampleId: new FormControl({ value: 0, disabled: true }),
    voucherIdentifier: new FormControl({ value: '', disabled: true }),
    retestYear: new FormControl(0),
    retestQuarter: new FormControl(0),
    tier: new FormControl(0),
    comments: new FormControl(''),
    completedDate: new FormControl(new Date()),
    dueBy: new FormControl(new Date())
  });

  retest: Retest = {
    id: 0,
    reviewDate: '',
    voucherId: 0,
    voucherLetterId: 0,
    householdId: 0,
    householdLetterId: 0,
    orgininalSampleId: 0,
    retestSampleId: 0,
    retestType: '',
    createDate: '',
    createdBy: '',
    modifiyDate: '',
    mdifiedby: '',
    comments: '',
    retestQuarter: 0,
    retestYear: 0,
    dueBy: '',
    isComplete: false,
    completedDate: '',
    tier: 0,
    voucherIdentifier: '',
    highestNitrateSampleId: 0,
    highestNitrateTier: 0,
    highestNitrateValue: '',
    voucherStatus: '',
    incomplete: false,
    incompleteReason: ''
  }

  constructor(public retestService: RetestService, public oregonWellDataService: OregonWellDataService, public authService: AuthService,
    private toastr: ToastrService, @Inject(MAT_DIALOG_DATA) public data: number, private dialogRef: MatDialogRef<DialogEditRetestsComponent>) {
    this.retestId = this.data;
  }

  ngOnInit(): void {
    this.processing = true;
    this.loading = true;

    this.retestService.getRetest(this.retestId).subscribe(
      result => {
        this.retest = result;
        this.setFormValues();
        this.processing = false;
        this.loading = false;
      },
      error => {
        this.processing = false;
        this.loading = false;
      }
    );
  }

  getFormValues() {
    // cant update
    this.retest.orgininalSampleId = 0;
    this.retest.retestSampleId = 0;
    this.retest.householdId = 0;
    this.retest.householdLetterId = 0;
    this.retest.voucherIdentifier = '';
    this.retest.voucherLetterId = 0;

    // from UI
    this.retest.isComplete = this.retestForm.value.isComplete;
    this.retest.incomplete = this.retestForm.value.incomplete;
    this.retest.retestType = this.retestForm.value.retestType;
    this.retest.retestYear = this.retestForm.value.retestYear;
    this.retest.retestQuarter = this.retestForm.value.retestQuarter;
    this.retest.tier = this.retestForm.value.tier;
    this.retest.comments = this.retestForm.value.comments;

    if (this.retestForm.value.completedDate == null
      || this.retestForm.value.completedDate.toString() == "Invalid Date"
      || this.retestForm.value.completedDate.toString() == '') {

      this.retestForm.controls['completedDate'].setValue(null);
      this.retest.completedDate = null;

    }
    else {
      this.retest.completedDate = new Date(this.retestForm.value.completedDate);
    }
  
    if (this.retestForm.value.dueBy == null
      || this.retestForm.value.dueBy.toString() == "Invalid Date"
      || this.retestForm.value.dueBy.toString() == '') {

      this.retestForm.controls['dueBy'].setValue(null);
      this.retest.dueBy = null;

    }
    else {
      this.retest.dueBy = new Date(this.retestForm.value.dueBy);
    }
  }

  onSubmit() {
    this.processing = true;
    this.getFormValues();

    this.retestService.saveRetest(this.retest).subscribe(
      result => {
        this.toastr.success("Retest Updated");
        this.processing = false;
      },
      error => {
        this.processing = false;
        this.toastr.error("Retest did not Update " + error.message);
      },
      () => {
        this.dialogRef.close();
      }
    );
  }
  
  toggleStatusComplete() {
    console.log(this.retestForm.get('isComplete').value);
    if(this.retestForm.get('isComplete').value == true) {
      //set incomplete to false
      this.retestForm.get('incomplete').setValue(false);
    }
  }

  toggleStatusIncomplete() {
    console.log(this.retestForm.get('incomplete').value);
    if(this.retestForm.get('incomplete').value == true) {
      //set complete to false
      this.retestForm.get('isComplete').setValue(false);
    }
  }

  setFormValues() {
    this.retestForm.get('isComplete').setValue(this.retest.isComplete);
    this.retestForm.get('incomplete').setValue(this.retest.incomplete);
    this.retestForm.get('retestQuarter').setValue(this.retest.retestQuarter);
    this.retestForm.get('retestYear').setValue(this.retest.retestYear);
    this.retestForm.get('tier').setValue(this.retest.tier);
    this.retestForm.get('comments').setValue(this.retest.comments);   
    this.retestForm.get("completedDate").setValue((new Date(this.retest.completedDate)));
    this.retestForm.get("dueBy").setValue((new Date(this.retest.dueBy)));

    // read only
    this.retest.orgininalSampleId > 0
      ? this.retestForm.get('orgininalSampleId').setValue(this.retest.orgininalSampleId)
      : this.retestForm.get('orgininalSampleId').setValue(null);

    this.retest.retestSampleId > 0
      ? this.retestForm.get('retestSampleId').setValue(this.retest.retestSampleId)
      : this.retestForm.get('retestSampleId').setValue(null);

    this.retest.voucherIdentifier != ''
      ? this.retestForm.get('voucherIdentifier').setValue(this.retest.voucherIdentifier)
      : this.retestForm.get('voucherIdentifier').setValue('');

    this.retest.retestType != ''
      ? this.retestForm.get('retestType').setValue(this.retest.retestType)
      : this.retestForm.get('retestType').setValue('');
  }
}